import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function PaymentPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'Payment | PMP Exam Simulator';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="max-w-lg mx-auto px-4 py-12 text-center">
      <div className="p-8 border rounded-lg bg-card">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-yellow-100 flex items-center justify-center text-3xl">
          &#128176;
        </div>
        <h1 className="text-2xl font-bold mb-2">{t('payment.title')}</h1>
        <p className="text-muted-foreground mb-6">{t('payment.subtitle')}</p>

        <div className="p-4 bg-muted rounded-lg mb-6 text-sm text-muted-foreground">
          {t('payment.gatewayPlaceholder')}
        </div>

        <div className="flex gap-4 justify-center">
          <Link to="/pricing" className="px-4 py-2 border rounded-lg hover:bg-accent">
            {t('common.cancel')}
          </Link>
          <Link
            to="/contact"
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90"
          >
            {t('payment.contactAdmin')}
          </Link>
        </div>
      </div>
    </div>
  );
}
